import { useField } from "formik";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface CheckboxFieldProps {
  name: string;
  label: string;
  hint?: string;
}

/** Formik-bound shadcn Checkbox, matching FormField's error-rendering style. */
export function CheckboxField({ name, label, hint }: CheckboxFieldProps) {
  const [field, , helpers] = useField({ name, type: "checkbox" });

  return (
    <div className="flex items-start gap-2">
      <Checkbox
        id={name}
        checked={!!field.value}
        onCheckedChange={(checked) => helpers.setValue(checked === true)}
        className="mt-0.5"
      />
      <div className="grid gap-0.5">
        <Label htmlFor={name} className="cursor-pointer font-normal">
          {label}
        </Label>
        {hint && <p className="text-muted-foreground text-xs">{hint}</p>}
      </div>
    </div>
  );
}
